var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoText(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 177.41,
    height: 18.927,
    viewBox: "0 0 177.41 18.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_16113",
    "data-name": "Grupo 16113",
    transform: "translate(-116.437 -14.286)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24966",
    "data-name": "Caminho 24966",
    d: "M175.13,62.674c0-1.7-1.185-2.618-3.086-2.618h-2.089v5.285h2.163c1.9,0,3.013-1.137,3.013-2.617Zm-2.711,6.049h-2.464v5.185H165.3V56.624h7.487c4.123,0,6.618,2.446,6.618,5.975v.05c0,4-3.111,6.075-6.988,6.075",
    transform: "translate(-48.866 -41.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24967",
    "data-name": "Caminho 24967",
    d: "M201.548,62.526c0-1.629-1.136-2.469-2.988-2.469h-2.928V65.02h3c1.852,0,2.914-.988,2.914-2.445Zm-.074,11.383-3.7-5.53h-2.138v5.53h-4.653V56.624h8.327c4.074,0,6.519,2.148,6.519,5.7v.05a5.367,5.367,0,0,1-3.7,5.357l4.222,6.172Z",
    transform: "translate(-59.323 -41.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_3950",
    "data-name": "Ret\\xE2ngulo 3950",
    width: 4.652,
    height: 17.285,
    transform: "translate(148.619 15.342)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24968",
    "data-name": "Caminho 24968",
    d: "M242.748,65.267c0-3.063-2.1-4.786-5.211-4.786h-2.089v9.57h2.089c3.111,0,5.211-1.673,5.211-4.735Zm-4.786,8.642H230.8V56.624h7.166c5.432,0,9.186,3.729,9.186,8.593v.05c0,4.865-3.754,8.642-9.186,8.642",
    transform: "translate(-75.541 -41.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24969",
    "data-name": "Caminho 24969",
    d: "M260.508,73.909V56.624h13.417v3.807h-8.789v3.083h8.789V66.9h-8.789v3.2h8.789v3.807Z",
    transform: "translate(-87.642 -41.282)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24970",
    "data-name": "Caminho 24970",
    d: "M298.417,73.769c-5.751,0-9.307-4.183-9.307-9.438a9.189,9.189,0,0,1,9.176-9.489,9.638,9.638,0,0,1,6.823,2.431l-1.333,1.568a7.787,7.787,0,0,0-5.569-2.091c-4.052,0-6.954,3.425-6.954,7.529,0,4.393,2.8,7.634,7.242,7.634a8.621,8.621,0,0,0,5.28-1.83V65.534h-5.569V63.678h7.555v7.293a11.087,11.087,0,0,1-7.346,2.8",
    transform: "translate(-99.291 -40.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24971",
    "data-name": "Caminho 24971",
    d: "M322.855,55.37h2.065V71.762h10.3V73.67H322.855Z",
    transform: "translate(-113.035 -40.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24972",
    "data-name": "Caminho 24972",
    d: "M354.128,56.751a7.2,7.2,0,0,0-7.163,7.529,7.283,7.283,0,0,0,7.216,7.582,7.2,7.2,0,0,0,7.163-7.53,7.283,7.283,0,0,0-7.216-7.581m0,17.018a9.464,9.464,0,1,1,9.359-9.49,9.191,9.191,0,0,1-9.359,9.49",
    transform: "translate(-121.982 -40.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24973",
    "data-name": "Caminho 24973",
    d: "M394.156,68.521c0-2.015-1.673-3.164-4.863-3.164h-5.777v6.457h6.143c2.771,0,4.5-1.229,4.5-3.293m-1.019-8.288c0-1.83-1.439-3.007-4.052-3.007h-5.569v6.3h5.411c2.484,0,4.209-1.125,4.209-3.3m2.092-.287a4.427,4.427,0,0,1-2.9,4.261c2.17.653,3.921,1.909,3.921,4.444,0,3.163-2.641,5.019-6.64,5.019h-8.13V55.37h7.791c3.608,0,5.961,1.778,5.961,4.576",
    transform: "translate(-136.912 -40.771)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24974",
    "data-name": "Caminho 24974",
    d: "M417.753,57.556l-4.183,9.333h8.339Zm9.333,16.024h-2.223l-2.143-4.835h-9.96L410.59,73.58h-2.118l8.339-18.43h1.935Z",
    transform: "translate(-147.907 -40.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Caminho_24975",
    "data-name": "Caminho 24975",
    d: "M443.76,55.37h2.065V71.762h10.3V73.67H443.76Z",
    transform: "translate(-162.279 -40.771)",
    fill: "#fff"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoText);
export default __webpack_public_path__ + "static/media/logo_text.6a33ab1e42abe3d021228ca22524bae9.svg";
export { ForwardRef as ReactComponent };